import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import queryString from "query-string";
import selectn from "selectn";
import debounce from "lodash/debounce";
import classNames from "classnames";

import { FRONTEND_ROOT } from "../../../config/constants";
import { getStoriesStream } from "../../../actions/storiesStream";
import { toggleAuthDrawer, changeStep, setPasswordResetInfo, confirmEmail } from "../../../actions/authDrawer";
import Header from "../../../components/Library/Header";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import LatestStories from "../../../components/Library/LatestStories";
import StoriesStream from "../../../components/Library/StoriesStream";
import SmarterFaster from "./SmarterFaster";
import * as authDrawerConstants from "../../../constants/authDrawer";
import analytics from "../../../utils/analytics";

import styles from "./TopStories.css";
import { a11yOnly } from "styles/global.css";

class TopStories extends Component {
  constructor(props) {
    super(props);
    this.loadNextStories = this.loadNextStories.bind(this);
  }

  componentDidMount() {
    this.scrollListener = debounce(this.handleScroll, 50);
    window.addEventListener("scroll", this.scrollListener);

    const parsedQs = this.props.location ? queryString.parse(this.props.location.search) : null;

    // If reset_password_token is present in the query string, open the drawer and point to the new password option
    if (parsedQs && parsedQs.reset_password_token) {
      this.props.changeStep(authDrawerConstants.FORGOTPASSWORD3);
      this.props.toggleAuthDrawer(true);
      this.props.setPasswordResetInfo(parsedQs.reset_password_token, parsedQs.email);
    }

    // If email_confirmation_token is present, confirm the email
    if (parsedQs && parsedQs.email_confirmation_token && parsedQs.email) {
      this.props.confirmEmail(parsedQs.email_confirmation_token, parsedQs.email);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.scrollListener);
  }

  handleScroll = () => {
    const cards = document.getElementsByClassName("story-card");
    if (cards) {
      for(let i=0; i < cards.length; i++) {
        let card = cards[i];

        if (analytics.isStoryInView(card)) {

          // Find hidden permalink
          let permalink = card.getAttribute("data-permalink");
          let to = permalink && permalink.replace(FRONTEND_ROOT, "");

          // Change history if it's different from url
          if (to && window.location.pathname !== to) {
            history.pushState({}, "", to);

            setTimeout(() => {
              if (window.location.pathname === to) {
                const stream = this.props.stream || selectn("match.params.tag", this.props) || "top";
                if (selectn("story.id", this.props) === card.id) {
                  analytics.userScrollsStoryIntoView({ story: this.props.story, stream });
                } else {
                  const stories = this.props.storiesStream.results.filter((story) => story.id === card.id);
                  if (stories && stories.length) {
                    analytics.userScrollsStoryIntoView({ story: stories[0], stream });
                  }
                }
              }
            }, 3000);
          }
          break;
        }
      }
    }
  };

  getParams = (props, state, page) => {
    const { section } = props;
    const { lastSeen } = props;
    return Object.assign(
      {},
      page && { page } || {},
      section && { stream: section.slug.toLowerCase() } || {},
      lastSeen && { featured_return_id: lastSeen } || {}
    );
  };

  loadNextStories(page) {
    return this.props.getStoriesStream(this.getParams(this.props, this.state, page), true);
  }

  getHeader = () => {
    if (!this.props.isTagPage) return null;
    return <Header className={styles.tag} text={selectn("section.name", this.props)}/>;
  };

  render() {
    let unread = 0;
    const isSmarterFaster = this.props.section && this.props.section.slug === "smarter-faster";

    this.props.lastSeen && this.props.storiesStream.results.slice(0, 21).map((story, index) => {
      if (this.props.lastSeen === story.id) {
        unread = index;
      }
    });

    const header = this.getHeader();
    const sectionName = selectn("section.name", this.props) || (this.props.onlyShowSectionForA11y && "Stories");

    return (
      <Layout includeHeader={!!header} headerComponent={header}>
        <Sidebar>
          <LatestStories/>
        </Sidebar>
        <Content className={styles.content} ariaLabel="Stories">
          {
            isSmarterFaster ?
              <SmarterFaster/> :
              (sectionName || unread > 0) &&
              <h2 className={classNames(styles.unread, { [a11yOnly]: this.props.onlyShowSectionForA11y })}>
                {sectionName || null}
                {sectionName && unread > 0 && " / "}
                {unread > 0 && `${unread > 20 ? "20+" : unread} Unread Stor${unread === 1 ? "y" : "ies"}`}
              </h2>
          }
          <StoriesStream
            stream={this.props.stream || "top"}
            adId={this.props.adId}
            showAds={true}
            stories={this.props.storiesStream}
            lastSeenId={this.props.lastSeen}
            showUnread={true}
            next={this.props.loadNextPage || this.loadNextStories}
            permalinkId={this.props.permalinkId}
            ssrStories={this.props.ssrStories}
          />
        </Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    story: state.storiesStream.data,
    storiesStream: state.storiesStream,
    sections: selectn("navigation.results.sections", state),
    section: selectn("navigation.data.section", state),
    lastSeen: selectn("navigation.data.lastSeen", state),
  };
};

TopStories.propTypes = {
  storiesStream: PropTypes.object,
  stream: PropTypes.string,
  permalinkId: PropTypes.string,
  onlyShowSectionForA11y: PropTypes.bool,
  ssrStories: PropTypes.number,
};

export default withRouter(connect(mapStateToProps, { getStoriesStream, toggleAuthDrawer, confirmEmail, changeStep, setPasswordResetInfo  })(TopStories));
